import { UnloggedScreenLayout } from '@/components/UnloggedScreenLayout/UnloggedScreenLayout'

export const Login = () => {
  return <UnloggedScreenLayout />
}
